import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconStopped = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9.5 7.75C8.5335 7.75 7.75 8.5335 7.75 9.5V14.5C7.75 15.4665 8.5335 16.25 9.5 16.25H14.5C15.4665 16.25 16.25 15.4665 16.25 14.5V9.5C16.25 8.5335 15.4665 7.75 14.5 7.75H9.5ZM9.25 9.5C9.25 9.36193 9.36193 9.25 9.5 9.25H14.5C14.6381 9.25 14.75 9.36193 14.75 9.5V14.5C14.75 14.6381 14.6381 14.75 14.5 14.75H9.5C9.36193 14.75 9.25 14.6381 9.25 14.5V9.5Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
		fill: "currentColor"
	})]
});
export { SvgIconStopped as ReactComponent };
